import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import failed from "../../assets/images/failed.png";
import success from "../../assets/images/succesasset.png";
import { apis } from '../../config/APIs';
const ReportAction = ({ type }) => {
  const location = useLocation();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (location.search) {
      const searchParams = new URLSearchParams(location.search)
      const approverToken = searchParams.get("approverToken")
      const emailAction = searchParams.get("emailAction")
      axios.post(type === "approve" ? apis.reportsApprove : apis.reportsReject, {}, {
        headers: {
          approverToken,
          emailAction
        }
      }).then(res => {
        setData(res.data)
      })
    }
    // eslint-disable-next-line
  }, [location.search])

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexDirection: "column"
    }}>
      <img src={data?.responseCode === "00" ? success : failed} alt="" style={{
        padding: "2rem 0"
      }} width={300} />
      {data?.responseCode === "00" ? "" : data?.errorMsg}
      <h2 style={{ color: "#333" }}>Report {type} {data?.responseCode === "00" ? "Successful" : "Unsuccessful"}.</h2>
      <p></p>
    </div>
  );
};

export default ReportAction;